import { IconWrapper } from '../runtime';
export default IconWrapper('open', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M4.5 7.99976H10.5M10.5 7.99976L8 5.49976M10.5 7.99976L8 10.4998M15 7.99969C15 11.8657 11.866 14.9997 8 14.9997C4.13401 14.9997 1 11.8657 1 7.99969C1 4.1337 4.13401 0.999695 8 0.999695C11.866 0.999695 15 4.1337 15 7.99969Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});